import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public mtds: Methods = new Methods();
  public url: string;
  public token;
  public user;
  public headers: HttpHeaders;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url + '/tabladinamica/';
    this.token = JSON.parse(localStorage.getItem('token'));
    this.user = JSON.parse(localStorage.getItem('identity'));
    if (this.token === 'undefined') {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  setConfig(table: string, config): Observable<any> {
    const json = { user_id: this.user.sub, name: table, data: JSON.stringify(config) };
    console.log(json);
    return this.petition(this.url + 'new', json);
  }

  getConfig(table): Observable<any> {
    const json = { user_id: this.user.sub, name: table };
    return this.petition(this.url + 'list', json);
  }

  petition(url, json = null, type = null): Observable<any> {

    this.token = JSON.parse(localStorage.getItem('token'));
    
    let params = 'authorization=' + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + '&json=' + json;
    }

    if (type != null) {
      params = params + '&type=' + type;
    }

    return this._http.post<any>(url, params, { headers: this.headers })
      .pipe(
        map(response => {
          if (response.code === 404) {
            this.mtds.notifyError('Your session has expired');
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
          return response;
        }),
        catchError((error: HttpErrorResponse) => {
          // Handle and forward the error
          console.error('An error occurred:', error);
          return throwError('Something went wrong. Please try again later.');
        })
      );
  }
}
